import { render, staticRenderFns } from "./TheUpsertLocalization.vue?vue&type=template&id=61bf71a2"
import script from "./TheUpsertLocalization.vue?vue&type=script&lang=ts"
export * from "./TheUpsertLocalization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports